var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c("w-col", { attrs: { xs: "12" } }, [
        _vm._v(" " + _vm._s(_vm.$ct("only-applicable-with-pdfs")) + " "),
      ]),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6", "no-margin": "" } },
        [
          _c(
            "w-col",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$ct("title"))),
              ]),
              _c("w-input", {
                attrs: { label: _vm.$ct("value"), fancy: "" },
                model: {
                  value: _vm.value.Title,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "Title", $$v)
                  },
                  expression: "value.Title",
                },
              }),
              _c("w-checkbox", {
                attrs: { label: _vm.$ct("ask-on-create") },
                model: {
                  value: _vm.value.AskTitle,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "AskTitle", $$v)
                  },
                  expression: "value.AskTitle",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$ct("sub-title-1"))),
              ]),
              _c("w-input", {
                attrs: { label: _vm.$ct("value"), fancy: "" },
                model: {
                  value: _vm.value.SubTitle1,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "SubTitle1", $$v)
                  },
                  expression: "value.SubTitle1",
                },
              }),
              _c("w-checkbox", {
                attrs: { label: _vm.$ct("ask-on-create") },
                model: {
                  value: _vm.value.AskSubTitle1,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "AskSubTitle1", $$v)
                  },
                  expression: "value.AskSubTitle1",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$ct("sub-title-2"))),
              ]),
              _c("w-input", {
                attrs: { label: _vm.$ct("value"), fancy: "" },
                model: {
                  value: _vm.value.SubTitle2,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "SubTitle2", $$v)
                  },
                  expression: "value.SubTitle2",
                },
              }),
              _c("w-checkbox", {
                attrs: { label: _vm.$ct("ask-on-create") },
                model: {
                  value: _vm.value.AskSubTitle2,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "AskSubTitle2", $$v)
                  },
                  expression: "value.AskSubTitle2",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$ct("foot-text-1"))),
              ]),
              _c("w-input", {
                attrs: { label: _vm.$ct("value"), fancy: "" },
                model: {
                  value: _vm.value.FootText1,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "FootText1", $$v)
                  },
                  expression: "value.FootText1",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$ct("foot-text-2"))),
              ]),
              _c("w-input", {
                attrs: { label: _vm.$ct("value"), fancy: "" },
                model: {
                  value: _vm.value.FootText2,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "FootText2", $$v)
                  },
                  expression: "value.FootText2",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            [
              _c("app-page-settings-default", {
                attrs: { value: _vm.value.PageSettings },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("app-page-settings-background-image", {
            attrs: { value: _vm.value.PageSettings },
          }),
          _c("hr"),
          _c("app-page-settings-font", {
            attrs: { value: _vm.value.PageSettings },
          }),
          _c("hr"),
          _c("app-side-by-side-settings", { attrs: { settings: _vm.value } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }